module.exports = __webpack_public_path__ + "assets/img/cv.6d3418fe.png";